import { render, staticRenderFns } from "./Ouch.vue?vue&type=template&id=5fa3c652&"
import script from "./Ouch.vue?vue&type=script&lang=js&"
export * from "./Ouch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports